<template>
  <div
    id="CourseInformation"
    v-loading="loading"
    class=""
    style="padding: 0 20px"
  >
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="课程名称:" :required="false">
              <span>{{ form.videoTitle }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="办学形式:" :required="false">
              <span>{{
                form.zkolCourseDetail.zkolBaseDictTypeVO.typeName
              }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="课程代码:" :required="false">
              <span>{{ form.zkolCourseDetail.courseCode }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple" style="position: relative">
            <div
              style="
                width: 90%;
                height: 250px;
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img :src="imageUrl" style="max-width: 100%; max-height: 250px" />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9"
          ><div class="grid-content bg-purple">
            <div class="grid-content bg-purple">
              <el-form-item label="关联专业:" :required="false">
                <span>{{ form.zkolCourseDetail.majorName }}</span>
              </el-form-item>
            </div>
          </div></el-col
        >
        <el-col :span="9"
          ><div class="grid-content bg-purple">
            <el-form-item label="建课时间:">
              <span>{{ ctime }}</span>
            </el-form-item>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-form-item label="所属机构:" :required="false">
              <span>{{ form.zkolCourseDetail.institutionName }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-form-item label="创建人:" :required="false">
              <span>{{ form.uname }}</span>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-form-item label="推送机构:" :required="false">
              <span>{{ form.mhmName }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="9"
          ><div class="grid-content bg-purple">
            <el-form-item label="创建时间:">
              <span>{{ ctime }}</span>
            </el-form-item>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="课程简介:" :required="false">
              <quill-editor
                ref="quillEditor"
                v-model="form.videoIntro"
                :options="options"
              >
                <div id="toolbar" slot="toolbar">
                  <button class="ql-bold" title="加粗">Bold</button>
                  <button class="ql-italic" title="斜体">Italic</button>
                  <button class="ql-underline" title="下划线">underline</button>
                  <button class="ql-strike" title="删除线">strike</button>
                  <button class="ql-blockquote" title="引用"></button>
                  <button class="ql-code-block" title="代码"></button>
                  <button
                    class="ql-list"
                    value="ordered"
                    title="有序列表"
                  ></button>
                  <button
                    class="ql-list"
                    value="bullet"
                    title="无序列表"
                  ></button>
                  <button class="ql-indent" value="+1" title="首行缩进">
                    indent
                  </button>
                  <select class="ql-header" title="段落格式">
                    <option selected>段落</option>
                    <option value="1">标题1</option>
                    <option value="2">标题2</option>
                    <option value="3">标题3</option>
                    <option value="4">标题4</option>
                    <option value="5">标题5</option>
                    <option value="6">标题6</option>
                  </select>
                  <select class="ql-size" title="字体大小">
                    <option value="10px">10px</option>
                    <option value="12px">12px</option>
                    <option value="14px">14px</option>
                    <option value="16px" selected>16px</option>
                    <option value="18px">18px</option>
                    <option value="20px">20px</option>
                  </select>
                  <select class="ql-font" title="字体">
                    <option value="SimSun" selected></option>
                    <option value="SimHei"></option>
                    <option value="Microsoft-YaHei"></option>
                    <option value="KaiTi"></option>
                    <option value="FangSong"></option>
                    <option value="Arial"></option>
                    <option value="Times-New-Roman"></option>
                    <option value="sans-serif"></option>
                  </select>
                  <select
                    class="ql-color"
                    value="color"
                    title="字体颜色"
                  ></select>
                  <select
                    class="ql-background"
                    value="background"
                    title="背景颜色"
                  ></select>
                  <select class="ql-align" value="align" title="对齐"></select>
                  <button class="ql-clean" title="还原"></button>
                </div>
              </quill-editor>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="是否免费:" :required="false">
              <span v-if="form.isCharge == '1'">是</span>
              <span v-if="form.isCharge == '0'">否</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item
              label="是否允许分销:"
              :required="false"
              label-width="120px"
            >
              <span v-if="form.isMount == '1'">是</span>
              <span v-if="form.isMount == '0'">否</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item
              label="是否报名审核:"
              :required="false"
              label-width="120px"
            >
              <span v-if="form.isVerify == '1'">是</span>
              <span v-if="form.isVerify == '0'">否</span>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <div class="grid-content bg-purple">
              <el-form-item
                label="原价(市场价格):"
                :required="false"
                label-width="120px"
              >
                <span>{{ form.vprice }}</span>
              </el-form-item>
            </div>
          </div></el-col
        >
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="销售价格:" :required="false">
              <span>{{ form.tprice }}</span>
            </el-form-item>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="是否精选:" :required="false">
              <span v-if="form.isBest == '1'">是</span>
              <span v-if="form.isBest == '0'">否</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="精选排序:" :required="false">
              <span>{{ form.bestSort }}</span>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="学习模式:" :required="false">
              <span v-if="form.isOrder == '1'">顺序模式</span>
              <span v-if="form.isOrder == '0'">随机模式</span>
              <span>{{ form.mode }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="显示位置:" :required="false">
              <span v-if="form.showPlace == '2'">机构</span>
              <span v-if="form.showPlace == '1'">平台</span>
              <span v-if="form.showPlace == '0'">机构和平台</span>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item
              label="课程有效时间:"
              :required="false"
              label-width="120px"
            >
              <span>{{ form.term }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="上架时间:" :required="false">
              <span>{{ listingtime }}</span>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="下架时间:" :required="false">
              <span>{{ uctime }}</span>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div
            class="grid-content bg-purple"
            style="text-align: center; padding-bottom: 30px"
          >
            <el-button type="primary" @click="getBack">返 回</el-button>
            <el-button v-if="userType !== '53'" type="primary" @click="edit"
              >修 改</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/course/courseInformation'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器

// 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
Quill.register(Size, true)

// 自定义字体类型
const fonts = [
  'simSum',
  'simHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
const Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

const Indent = Quill.import('formats/indent')
Indent.whitelist = [1]
Quill.register(Indent, true)

export default {
  name: 'CourseInformation',
  components: {
    quillEditor,
  },
  props: ['userType'],
  data() {
    return {
      loading: false,
      form: {
        name: '英语名称',
        types: '',
        code: '',
        career: '',
        datetime: '',
        createTime: '',
        organ: '',
        creater: '',
        pushOrgan: '',
        introduction: '',
        free: '',
        retail: '',
        verify: '',
        costPrice: '',
        sellPrice: '',
        validPeriod: '',
        onSale: '',
        startTime: '',
        offSale: '',
        endTime: '',
        offClassTime: '',
        culling: '',
        sort: '',
        mode: '',
        locations: '',
      },
      pushOrganList: [
        '华南理工大学1',
        '华南理工大学2',
        '华南理工大学3',
        '华南理工大学4',
      ],
      imageUrl: '',
      options: {
        placeholder: '',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
    }
  },
  methods: {
    getParams() {
      let id = this.$route.query.id
      api.getCourseDetail({ id, uid: this.getUId }).then(({ data }) => {
        data = data.data
        this.form = data
        this.ctime = this.formatDate(data.ctime)
        this.listingtime = this.formatDate(data.listingtime)
        this.uctime = this.formatDate(data.uctime)
        this.imageUrl = this.url + '/data/upload/' + data.fileName
      })
      // if(this.$route.query.vo!=null){
      // this.form.name = this.$route.query.vo.name
      // this.form.content = this.$route.query.vo.detailed
      // this.form.effectiveDate = this.$route.query.vo.effectiveDate
      // this.form=this.$route.query.vo
      // }
    },

    formatDate: function (value) {
      let date = new Date(parseInt(value) * 1000)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    },
    getTime(time) {
      let date = new Date(time)
      let y = date.getFullYear()
      let m =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return y + '-' + m + '-' + d
    },

    // 获取数据
    getList() {
      // this.loading = true
    },

    edit() {
      // const url = 'CourseAdd'
      // this.$emit('set-active-from-sub', url)
      // this.$router.push(url)
      // window.open('http://gz.hnjk.net/index.php?app=course&mod=AdminVideo&act=addVideo&tabHash=editVideo&id='+this.$route.query.id,'_blank')
      let url = this.url
      if (window.location.host === 'fxl.sce.scut.edu.cn') {
        url += '/zk'
      }
      window.location.href =
        url +
        '/index.php?app=course&mod=AdminVideo&act=addVideo&tabHash=editVideo&id=' +
        this.$route.query.id
    },

    getBack() {
      // window.open('http://gz.hnjk.net/index.php?app=course&mod=AdminVideo&act=index','_blank')
      let url = this.url
      if (window.location.host === 'fxl.sce.scut.edu.cn') {
        url += '/zk'
      }
      window.location.href =
        url + '/index.php?app=course&mod=AdminVideo&act=index'
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/png']
      const isImage = types.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    },
  },
  created() {
    this.getParams()
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.ql-editor {
  min-height: 300px;
}
.el-tabs__item {
  font-size: 14px !important;
}
</style>
